import React, { Component } from "react";
import "./App.css";
import Marketing from "./marketing/Marketing";

class App extends Component {
  render() {
    return <Marketing />;
  }
}

export default App;
